/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { InputItem } from 'antd-mobile';
import CustomSlider from '@/components/CustomSlider';
import { fixedBody, looseBody } from '@/utils/fn';
import {
  DEFAULT_FILTER_DATA,
  DEFAULT_MORE_FILTER,
  DEVICE_TYPE,
  INPUT_MODE,
  ISP_TYPE,
  LIST_MODE,
  MORE_TYPE,
  PROVINCE_TYPE,
  SLIDER_MODE,
} from '../config/pars';
import styles from '../styles/filter.less';

const BizFilterPanel = ({
  visible,
  type,
  closeFilterPanel,
  onConfirm = () => {},
  filterOptions,
  choosenData,
  origin,
  customStyle = {},
}) => {
  const filterBodyRef = useRef(null);
  const moneyKeyboardWrapProps = useMemo(() => {
    if (origin === '2' || origin === '4')
      return {
        onTouchStart: e => e.preventDefault(),
      };
  }, [origin]);

  // 当前选择的条件
  const [filterData, setFilterData] = useState({ ...DEFAULT_FILTER_DATA });

  const handleClosePanel = useCallback(() => {
    closeFilterPanel();
    // 点击蒙层关闭不保留数据，恢复打开蒙层时的数据
    setFilterData(choosenData);
  }, [choosenData]);

  const handleSilderChange = useCallback(
    (current, type) => {
      const curData = filterData[MORE_TYPE] || {};
      setFilterData({
        ...filterData,
        [MORE_TYPE]: {
          ...curData,
          [type]: String(current),
        },
      });
    },
    [filterData]
  );

  const handleListItemClick = useCallback(
    (value, type) => {
      let curChooseItems = filterData[type] || [];
      if (curChooseItems.includes(value)) {
        curChooseItems = curChooseItems.filter(item => item !== value);
      } else {
        // 防止浅拷贝影响default选项
        curChooseItems = [...curChooseItems, value];
      }
      setFilterData({
        ...filterData,
        [type]: curChooseItems,
      });
    },
    [filterData]
  );

  const handleMoreOptionClick = useCallback(
    (value, type) => {
      const moreFilters = filterData[MORE_TYPE] || {};
      let curChooseItems = moreFilters[type] || [];
      if (curChooseItems.includes(value)) {
        curChooseItems = curChooseItems.filter(item => item !== value);
      } else {
        curChooseItems = [...curChooseItems, value];
      }
      setFilterData({
        ...filterData,
        [MORE_TYPE]: {
          ...moreFilters,
          [type]: curChooseItems,
        },
      });
    },
    [filterData]
  );
  const handleConfirmBtnClick = useCallback(() => {
    closeFilterPanel();
    onConfirm(filterData);
  }, [filterData]);

  const handleResetBtnClick = useCallback(() => {
    const resetData = type === MORE_TYPE ? { ...DEFAULT_MORE_FILTER } : [];
    // 此处数据不同步到外层
    setFilterData({
      ...filterData,
      [type]: resetData,
    });
  }, [filterData, type]);

  const renderMoreFilter = useCallback(
    info => {
      // console.log('filterData: ', filterData);
      const { id, data = [], type, title, unit } = info;
      switch (type) {
        case LIST_MODE:
          return (
            <ul className={`${styles['filter-labels']} ${styles['list-labels']}`}>
              {data?.map(option => {
                const { label, value } = option;
                return (
                  <li
                    className={`${
                      filterData[MORE_TYPE][id]?.includes(value) ? styles['active'] : ''
                    }`}
                    key={value}
                    onClick={() => handleMoreOptionClick(value, id)}
                  >
                    {label}
                  </li>
                );
              })}
            </ul>
          );
        case SLIDER_MODE:
          return (
            <div className={styles['slider-wrapper']}>
              <CustomSlider
                defaultValue={filterData[MORE_TYPE][id]}
                onChange={handleSilderChange}
                id={id}
                {...data}
              />
            </div>
          );
        case INPUT_MODE:
          return (
            <InputItem
              placeholder={`请输入${title}`}
              type="money"
              clear
              moneyKeyboardAlign="left"
              moneyKeyboardWrapProps={moneyKeyboardWrapProps}
              extra={unit}
              value={filterData[MORE_TYPE][id]}
              onChange={val => handleSilderChange(val, id)}
            />
          );
        default:
          return null;
      }
    },
    [filterData]
  );

  const rednerFilterOptions = useCallback(() => {
    //  当前筛选信息
    const filterInfo = filterOptions[type];
    switch (type) {
      case DEVICE_TYPE:
      case ISP_TYPE:
        return (
          <ul className={`${styles['filter-list']} ${styles[type]}`}>
            {filterInfo?.map(item => {
              const { value, label } = item;
              return (
                <li
                  className={`${styles['filter-option']} ${
                    filterData[type]?.includes(value) ? styles['active'] : ''
                  }`}
                  key={value}
                  onClick={() => handleListItemClick(value, type)}
                >
                  {label}
                </li>
              );
            })}
          </ul>
        );
      case PROVINCE_TYPE:
        return filterInfo?.map(provinceItem => (
          <ul className={styles['filter-list']} key={provinceItem.type}>
            {provinceItem.sub_list?.map((item, index) => {
              const { value, label } = item;
              return (
                <li
                  className={`${styles['filter-option']} ${
                    filterData[type]?.includes(value) ? styles['active'] : ''
                  }`}
                  key={value}
                  onClick={() => handleListItemClick(value, type)}
                >
                  {index === 0 && <em>{provinceItem.type}</em>}
                  {label}
                </li>
              );
            })}
          </ul>
        ));
      case MORE_TYPE:
        return (
          <div className={styles['more-filter']}>
            {filterInfo?.map(item => {
              return (
                <div className={styles['filter-type']} key={item.id}>
                  <h4 className={styles['filter-name']}>
                    {item.title}
                    {item.unit ? `(${item.unit})` : ''}
                  </h4>
                  {renderMoreFilter(item)}
                </div>
              );
            })}
          </div>
        );
      default:
        return null;
    }
  }, [type, filterData, filterOptions]);

  useEffect(() => {
    if (visible) {
      fixedBody();
    } else {
      looseBody();
    }
  }, [visible]);

  useEffect(() => {
    setFilterData(choosenData);
  }, [choosenData]);

  useEffect(() => {
    // 调整导航栏
    // if (filterBodyRef.current) {
    //   filterBodyRef.current?.scrollTo(0, 0);
    // }
    // type改变，还原筛选项
    setFilterData(choosenData);
  }, [type, choosenData]);

  return (
    <div
      className={`${styles['mask']} ${visible ? styles['show'] : ''}`}
      onClick={handleClosePanel}
    >
      <div
        className={styles['biz-filter-panel']}
        onClick={e => e.stopPropagation()}
        style={customStyle}
      >
        <div className={`${styles['filter-body']} ${styles[`${type}`]}`} ref={filterBodyRef}>
          {rednerFilterOptions()}
        </div>
        <div className={styles['btns']}>
          <button onClick={handleResetBtnClick}>重置</button>
          <button className={styles['confirm']} onClick={handleConfirmBtnClick}>
            完成
          </button>
        </div>
      </div>
    </div>
  );
};
export default BizFilterPanel;
